/**
 * Frontend config. BUN_PUBLIC_* env vars are exposed by Bun (see bunfig.toml).
 * Backend base URL for all API requests.
 */
// const DEFAULT_API_BASE_URL = "http://localhost:4000";
const DEFAULT_API_BASE_URL = "https://dev-trade-connect-api.fairfast.in.th/ff-simulation-api";


function getApiBaseUrl(): string {
  // We explicitly access process.env.BUN_PUBLIC_API_URL and import.meta.env.BUN_PUBLIC_API_URL
  // so that frontend bundlers (like Bun) can statically replace them.
  let raw: string | undefined;
  
  if (typeof process !== "undefined" && process.env && process.env.BUN_PUBLIC_API_URL) {
    raw = process.env.BUN_PUBLIC_API_URL;
  } else {
    // Fallback for bundlers that inject into import.meta.env
    const meta = import.meta as unknown as { env?: Record<string, string> };
    if (meta?.env?.BUN_PUBLIC_API_URL) {
      raw = meta.env.BUN_PUBLIC_API_URL;
    }
  }

  raw = raw?.trim();
  if (!raw) return DEFAULT_API_BASE_URL;
  return raw.replace(/\/+$/, "");
}

export const API_BASE_URL = getApiBaseUrl();
